module.exports = __webpack_public_path__ + "img/campaign-logo.35a51079.webp";